'use strict';

namespace Core {

    class ModalCancellationsDetails {
        show: boolean;
        public cancellationData;
        public roomId;
        public roomCancellationCharges;
        public marhabaCost = Number(sessionStorage.getItem('marhabaCost'));
        public hotelData = sessionStorage.getItem('hotelData');

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            )
        {
        }

        init (container : ng.IAugmentedJQuery) {
            let t = this;
            if (this.hotelData) {
                let hotelDataJson = JSON.parse(this.hotelData);
                if (hotelDataJson.RequestedRooms.length > 1) {
                    this.$scope.$on('multiRoomCancellationCharges', function(e, data) {
                        t.roomCancellationCharges = data;
                        t.formatEventName(t.roomCancellationCharges);
                    });
                }
            }

            this.broker.subscribe('modalCancellationsDetails', 'showModalCancellationsDetails', e => {
                this.show = true;
                this.roomId = e.data;

                if (this.hotelData) {
                    let hotelDataJson = JSON.parse(this.hotelData);

                    if (hotelDataJson.RequestedRooms.length === 1) {
                        this.cancellationData = TRPCONFIG.Domain.CancellationData;
                        this.compareData(this.cancellationData, this.roomId);
                    }
                }
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalCancellationsDetails');
            });
        }

        findEventType(eventType, price) {
            for (let i = 0; i < eventType.length; i++) {
                if (eventType[i] === 'Departure') {
                    return price + this.marhabaCost;
                }
            }
            return price;
        }

        formatEventName(data) {
            for (let i = 0; i < data.length; i++) {
                let eventType = data[i].EventTypes;
                for (let j = 0; j < eventType.length; j++) {
                    let chargeName = data[i].EventTypes[j];
                    chargeName = chargeName.replace(/([A-Z])/g, ' $1').trim();
                    data[i].EventTypes[j] = chargeName;
                }
            }
        }

        compareData(data, id) {
            let roomCancellationData = data.filter(function (d) {
                if (d.Id === id) {
                    return d;
                }
            });

            this.roomCancellationCharges = roomCancellationData[0].CancellationCharges;
            this.formatEventName(this.roomCancellationCharges);
        }
    }

    angular
        .module('core')
        .directive('modalCancellationsDetails', (): ng.IDirective => {

            return {
                scope: {},
                controller: ModalCancellationsDetails,
                controllerAs: 'mcd',
                templateUrl: 'partials/home/directivetemplate?type=CancellationsDetails',
                bindToController: {
                    roomId: '='
                },
                link: function (
                    scope : ng.IScope,
                    el : ng.IAugmentedJQuery,
                    attr,
                    controller : ModalCancellationsDetails) {
                    controller.init(el);
                }
            };
    });

}
